import $ from 'jquery';
import _ from 'underscore';
import Form from 'jquery-form';
import Ps from 'perfect-scrollbar';


class SportCalculators {
    constructor() {
        this.form = Form(document, $);

        $(document).ready(() => {
            if ($('#sport-calculator').length) {
                this.formSport = this.form('.js-sporting-calculations');
                this.formSportResult = this.form('#getSportResult');
                this.dataTeams = [];
                this.sportingResult = this.form('.js-sporting-result');
                this.sportingInfo = $('.js-sportiong-info');
                this.sportingWinRate = $('.js-sporting-win-rate');
                this.sportCalcsInfo = $('.js-sport-calcs-info');
                this.sportCalcsWinRate = $('.js-sport-calcs-win-rate');
                this.showLoaderEvent = new Event('loader.show');
                this.hideLoaderEvent = new Event('loader.hide');

                this.initScrollBars();
                this.listenForTeamsChange();
                this.updateTeamsList();
                this.calculateResult();
                this.showInfo();
                this.showWinRate();
            }
        });


    }

    initScrollBars() {
        this.scrollbarL = new Ps(this.sportCalcsInfo[0]);
        this.scrollbarR = new Ps(this.sportCalcsWinRate[0]);
    }

    listenForTeamsChange() {
        $('.js-team-leagues').change(this.updateTeamsList.bind(this));

        $('.js-team-one').on('change', (e) => {
            this.teamOneSelected = $(e.currentTarget).val();
            this.fillLists();
        });
        $('.js-team-two').on('change', (e) => {
            this.teamTwoSelected = $(e.currentTarget).val();
            this.fillLists();
        });
    }

    updateTeamsList() {
        this.dataTeams = JSON.parse($('.js-team-leagues:checked').data('teams'));
        this.fillLists();
    }

    showInfo() {
        this.sportingInfo.click(e => {
            if ($('.c-sport-calculator-left-side__show-info').length) {
                $('.c-sport-calculator-left-side__info-block').removeClass('c-sport-calculator-left-side__show-info');
                this.sportingInfo.text('INFO');
            } else {
                $('.c-sport-calculator-left-side__info-block').addClass('c-sport-calculator-left-side__show-info');
                $('.c-sport-calculator-right-side__win-rate').removeClass(' c-sport-calculator-right-side__show-win-rate');
                this.sportingInfo.text('CLOSE TEXT');
                this.sportingWinRate.text('WIN RATE');
            }
        });
    }

    showWinRate() {
        this.sportingWinRate.click(e => {
            if ($('.c-sport-calculator-right-side__show-win-rate').length) {
                $('.c-sport-calculator-right-side__win-rate').removeClass(' c-sport-calculator-right-side__show-win-rate');
                this.sportingWinRate.text('WIN RATE');
            } else {
                $('.c-sport-calculator-right-side__win-rate').addClass(' c-sport-calculator-right-side__show-win-rate');
                $('.c-sport-calculator-left-side__info-block').removeClass('c-sport-calculator-left-side__show-info');
                this.sportingWinRate.text('CLOSE STATS');
                this.sportingInfo.text('INFO');
            }
        });
    }

    viewMoreEvent() {
        $('.c-sport-calculator-content__view-expand').off('click').click(e => {
            if ($('.c-sport-calculator-content__result-view').length) {
                $('.c-sport-calculator-content__result').removeClass(' c-sport-calculator-content__result-view');
                $(e.currentTarget).text('VIEW MATCHES');
            } else {
                $(e.currentTarget).text('HIDE MATCHES');
                $('.c-sport-calculator-content__result').addClass(' c-sport-calculator-content__result-view');
            }

        });
    }

    calculateResult() {

        $('.c-sport-calculator-content__date input').keyup(() => {
            //this.sportingResult.removeClass('u-hidden');

        });
        let sportResultTemplate = _.template($('.c-gematry-sport__result-template').html());

        this.formSport.ajaxForm({
            'beforeSubmit': (arr, $form, options) => {
                let year = arr.filter(function (el) {
                    return el.name === 'year';
                })[0];

                let month = arr.filter(function (el) {
                    return el.name === 'month';
                })[0];

                let day = arr.filter(function (el) {
                    return el.name === 'day';
                })[0];

                //account for the fact that months begin from 0
                month = parseInt(month.value) - 1;

                let dateCheck = new Date(year.value, month, day.value);

                this.sportingResult.addClass('u-hidden');
                document.dispatchEvent(this.showLoaderEvent);

                return dateCheck instanceof Date && !isNaN(dateCheck) && dateCheck.getMonth() === month;

            },
            'success'     : (response) => {
                response = JSON.parse(response);
                document.dispatchEvent(this.hideLoaderEvent);
                this.formSportResult.html(sportResultTemplate(response));
                this.viewMoreEvent();
            },
            'error'       : (response) => {
                this.sportingResult.removeClass('u-hidden');
                this.parseErrors(response)
            }
        });

    }

    fillLists() {
        this.sportingResult.removeClass('u-hidden');
        let list1 = '<option value="" disabled selected>first team</option>';
        let list2 = '<option value="" disabled selected>second team</option>';

        for (let ind in this.dataTeams) {
            let name = this.dataTeams[ind];

            let selected1 = name === this.teamOneSelected ? 'selected' : '';
            let selected2 = name === this.teamTwoSelected ? 'selected' : '';

            if (name !== this.teamTwoSelected) {
                list1 += '<option value="' + name + '" ' + selected1 + '>' + name + '</option>';
            }
            if (name !== this.teamOneSelected) {
                list2 += '<option value="' + name + '" ' + selected2 + ' >' + name + '</option>';
            }
        }

        $('.js-team-one').html(list1);
        $('.js-team-two').html(list2);
    }

    parseErrors(response) {
        let results = '';
        for (let res in response.errors) {
            results += '<p>' + response.errors[res] + '</p>'
        }
        this.formSportResult.html(results);
    }

}

export default SportCalculators;